/*
 * 案件提案メンバー関連
 */
import { RFP_OFFER_MEMBER_MEMBER_TYPE_COMPANY_VALUE, RFP_OFFER_MEMBER_MEMBER_TYPE_OUTSIDE_VALUE, } from '@/utils/constants/rfp/rfpOfferMember/memberType';
/**
 * 社内メンバーか
 * @param memberType
 * @returns {boolean}
 */
export const isRfpOfferMemberTypeCompany = (memberType) => memberType === RFP_OFFER_MEMBER_MEMBER_TYPE_COMPANY_VALUE;
/**
 * 社外メンバーか
 * @param memberType
 * @returns {boolean}
 */
export const isRfpOfferMemberTypeOutside = (memberType) => memberType === RFP_OFFER_MEMBER_MEMBER_TYPE_OUTSIDE_VALUE;
